<template>
    <div :class="$style.page_toggles">
        <IconButton
            :class="props.currentPage <= 1 ? $style.disabled_override : ''"
            color="carbon-400"
            size="l"
            icon="chevron-left"
            :interfaceTarget="`click-page-${prevPage}`"
            :to="getPageLink(prevPage)"
        />

        <Button
            v-for="page in visiblePages"
            :key="page"
            size="l"
            :to="getPageLink(page)"
            :interfaceTarget="`click-page-${page}`"
            :label="page"
            :color="props.currentPage === page ? 'purple-400-flat' : 'carbon-400'"
        />
        <IconButton
            :class="props.currentPage >= props.totalPages ? $style.disabled_override : ''"
            color="carbon-400"
            size="l"
            :interfaceTarget="`click-page-${nextPage}`"
            icon="chevron-right"
            :to="getPageLink(nextPage)"
        />
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { RouteLocationRaw } from 'vue-router'

import Button from '@/components_new/Buttons/Button.vue'
import IconButton from '@/components_new/Buttons/IconButton.vue'
import { useDeviceSize } from '@/composables/use-device-size'

const props = withDefaults(
    defineProps<{
        totalPages?: number
        currentPage?: number
        numShow?: number
        mobileNumShow?: number
        step?: number
        getPageLink: (page: number) => RouteLocationRaw
    }>(),
    {
        totalPages: 5,
        currentPage: 1,
        numShow: 5,
        mobileNumShow: 3,
        step: 1,
    },
)

const prevPage = computed<number>(() => props.currentPage - 1)
const nextPage = computed<number>(() => props.currentPage + 1)
const { isTabletPlus } = useDeviceSize()

const visiblePages = computed<number[]>(() => {
    const { currentPage, totalPages, numShow, step, mobileNumShow } = props
    const visibleNumShow = isTabletPlus.value ? numShow : mobileNumShow
    const windowIndex = Math.floor(currentPage - step)
    let start = windowIndex * step + 1
    let end = start + visibleNumShow - 1

    if (end > totalPages) {
        end = totalPages
        start = Math.max(1, end - visibleNumShow + 1)
    }

    const pages: number[] = []
    for (let i = start; i <= end; i++) {
        pages.push(i)
    }

    return pages
})
</script>
<style module>
.page_toggles {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 16px 0;
}

.disabled_override {
    color: var(--white-20);
    --main: var(--carbon-400);
    pointer-events: none;
}

@media (--desktop-small-plus) {
    .page_toggles {
        padding: 8px 0;
    }
}
</style>
